module.exports = __webpack_public_path__ + "img/beijing04.38c85691.png";